import type Asset from '../asset';
import { FilterJSON, isRoundFilterJSON } from './types';
import type FilterOption from './filterOption';

export default class RoundFilter implements FilterOption {
	roundNumbers: number[];

	constructor( roundNumbers: number[] ) {
		this.roundNumbers = roundNumbers;
	}

	get id() {
		return `round-${[ ...this.roundNumbers ].sort( ( a, b ) => a - b ).join( '_' )}`;
	}

	get filterAmount() {
		return this.roundNumbers.length;
	}

	isPassedBy( asset: Asset ) {
		const assetRoundNumber = asset.currentRoundNumber;
		return assetRoundNumber !== undefined && this.roundNumbers.includes( assetRoundNumber );
	}

	toJson() {
		return { round: this.roundNumbers };
	}

	static fromJson( json: FilterJSON ) {
		return isRoundFilterJSON( json )
			? new RoundFilter( json.round )
			: null;
	}
}
